import { Component, Input, NgZone, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { ModalController, Platform } from '@ionic/angular';
import { BillService } from 'src/app/services/commons/bill.service';
import { Bill } from 'src/app/models/Bill';
import { DefaultModalComponent } from '../../../default-modal/default-modal.component';
import { Instruction } from 'src/app/models/Instruction';
import { GlobalVariablesService } from 'src/app/services/global-variables.service';
import { GlobalMethodsService } from 'src/app/services/global-methods.service';
import { StorageService } from 'src/app/services/commons/storage.service';
import { BillingDataComponent } from '../../../billing-data/billing-data.component';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { ProfileInstallationService } from 'src/app/services/commons/profile-installation.service';
import { NavigationService } from '../../../../../services/commons/navigation.service';
import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';
import { ModalService } from '../../../../../services/commons/modal.service';
import { BillDetailComponent } from './bill-detail/bill-detail.component';
import * as moment from 'moment';
import { FileSharer } from '@byteowls/capacitor-filesharer';
import { registerPlugin } from "@capacitor/core";
import { TranslateService } from '@ngx-translate/core';
const AppRatePlugin = registerPlugin<any>('AppRatePlugin');

@Component({
  selector: 'app-bills',
  templateUrl: './bills.component.html',
  styleUrls: ['./bills.component.scss'],
})
export class BillsComponent implements OnInit {

  @Input('alarmActivated') alarmActivated;
  public filterForm: FormGroup;
  public editPressed = false;
  public user: any;
  public instructions: Instruction[] = [];
  public bills: Bill[] = [];
  public text: string;
  public nameHolder: string;
  public addressHolder: string;
  public bankAccountHolder: string;
  public billsPaid: Bill[] = [];
  public unPaidBills: Bill[] = [];
  public isServiceBusy = false;
  public dateBegin: string = '';
  public dateEnd: string = '';
  public dateFrom = '';
  public dateTo = '';

  constructor(private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private zone: NgZone,
    private gvs: GlobalVariablesService,
    public gms: GlobalMethodsService,
    private infInstallationService: ProfileInstallationService,
    private storage: StorageService,
    private defaultModalComponent: DefaultModalComponent,
    private billService: BillService,
    public navigation: NavigationService,
    private translate: TranslateConfigService,
    private trans: TranslateService,
    public modalService: ModalService,
    public platform: Platform) { }

  ngOnInit() {
    this.filterForm = this.formBuilder.group({
      date_since: new FormControl('', []),
      date_until: new FormControl('', [])
    });
  }
  async ionViewWillEnter() {
    this.gms.loading();
    this.gms.analyticsTrackEvent('openScreen', { screenName: 'Facturas', contentGroup: 'Facturas' });
    await this.gms.clearIntervalStatusInstallationEvent();
    this.user = this.gvs.user;
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      try {
        this.instructions = await this.infInstallationService.gAppuserText(this.user.userName, this.gvs.lang, 7, 'SIC1200_0010', 'invoices');
        this.text = this.instructions[0].texts;
      }
      catch (e) {
        const message = JSON.stringify(e);
        await FirebaseCrashlytics.recordException({ message: message });
        this.modalCtrl.dismiss(false, '', 'loadSpinner');
        this.modalCtrl.dismiss(false, '', 'billsModal');
      }
    } else {
      this.modalCtrl.dismiss(false, '', 'billsModal');
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
    if (this.gvs.currentInstallation == null) {
      const installations = await this.storage.getObject(this.gvs.CONF_INSTALLATIONS + '_' + this.user.userName);
      this.gvs.currentInstallation = installations.find(x => x.selected === 1);
    }
    await this.getBills(this.user.userName, this.gvs.currentInstallation.s_ins, this.filterForm.controls.date_since.value,
      this.filterForm.controls.date_until.value);
    if (this.bills == undefined) {
      this.bills = [];
      return;
    }
    this.getBillingData();
    this.loadUnpaidBills();
    this.loadBillsPaid();
    this.modalCtrl.dismiss(false, '', 'loadSpinner');
  }

  async getBills(user: string, s_ins: number, start_dt: string, end_dt: string) {
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      this.bills = await this.billService.isAppuserInvoices(user, s_ins, start_dt, end_dt);
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  getBillingData() {
    this.nameHolder = this.bills.length > 0 ? this.bills[0].name : '';
    const street = this.bills.length > 0 ? this.bills[0].street1 : '';
    const zip = this.bills.length > 0 ? this.bills[0].zip.trim() : '';
    const city = this.bills.length > 0 ? this.bills[0].city : '';
    const street2 = zip === '' && city === '' ? '' : ', ' + zip + ' ' + city;
    this.addressHolder = street + street2;
    this.bankAccountHolder = this.bills.length > 0 ? this.bills[0].pay_account : '';
  }

  loadUnpaidBills() {
    this.unPaidBills = this.bills.filter(x => x.due === 'X');
  }

  loadBillsPaid() {
    this.billsPaid = this.bills.filter(x => x.due != 'X');
  }

  dismiss(value) {
    this.modalService.hide('billsModal', value);
  }

  dateChange(date, source:string){
    moment.locale('es');
    if (source === 'since'){
      this.dateBegin = moment(date).format('L')
      this.dateFrom = date;
    }else if (source === 'until'){
      this.dateEnd = moment(date).format('L');
      this.dateTo = date;
    }
  }

  async onSubmit() {
    if (this.isServiceBusy) {
      return;
    }
    this.gms.analyticsTrackEvent('invoices', { eventCategory: 'SICOR/Facturas', eventAction: 'Accion/Buscar Click' });
    if (this.filterForm.valid) {
      this.isServiceBusy = true;
      this.gms.loading();
      if (this.filterForm.controls.date_since.value == null || this.filterForm.controls.date_since.value == '') {
        this.dateBegin = this.gms.dateFormat(new Date(), 'DD/MM/YYYY');
        this.dateFrom = this.gms.dateFormat(new Date(), 'YYYY-MM-DD');
      }
      if (this.filterForm.controls.date_until.value == null || this.filterForm.controls.date_until.value == '') {
        this.dateEnd = this.gms.dateFormat(new Date(), 'DD/MM/YYYY');
        this.dateTo = this.gms.dateFormat(new Date(), 'YYYY-MM-DD');
      }
      await this.getBills(this.user.userName, this.gvs.currentInstallation.s_ins, moment(this.dateTo).format('DD/MM/YY'), moment(this.dateFrom).format('DD/MM/YY'));
      this.getBillingData();
      this.loadUnpaidBills();
      this.loadBillsPaid();
      this.modalCtrl.dismiss(false, '', 'loadSpinner');
      this.isServiceBusy = false;
    } else {
      this.validateAllFormFields(this.filterForm);
    }
  }

  isFieldValid(field: string) {
    return !this.filterForm.get(field).valid && this.filterForm.get(field).touched;
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (!control.valid) {
        this.gms.analyticsTrackEvent('form_error', { eventCategory: 'SICOR/Facturas', eventAction: 'Error/Form: Filtro Facturas', eventLabel: 'Campo: ' + field });
      }
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  // Open modal: billing data
  async billingData() {
    this.editPressed = true;

    // open modal
    const contentModal = await this.modalCtrl.create({
      component: BillingDataComponent,
      componentProps: {
        nameHolder: this.nameHolder,
        addressHolder: this.addressHolder,
        bankAccountHolder: this.bankAccountHolder
      },
      cssClass: ['w-modal-md']
    });

    contentModal.onDidDismiss().then(data => {
      this.zone.run(() => {
        this.editPressed = false;
      });
    });

    contentModal.present().then();
  }

  async downloadBill(bill: any, invoiceDate: any) {
    // const checkInternet = await this.gms.checkInternet();
    // if (checkInternet) {
    //   this.gms.analyticsTrackEvent('invoice_action', {eventCategory: 'SICOR/Descarga Factura', eventAction: 'Accion/Descarga Factura Inicio', eventLabel: moment(bill.invoice_date).format('MM/YY') });
    //   const response = await this.billService.gAppuserInvoiceDwl(this.user.userName, bill.invoice);
    //   if (response != null) {
    //     this.gms.analyticsTrackEvent('invoice_action', {eventCategory: 'SICOR/Descarga Factura', eventAction: 'Accion/Descarga Factura OK', eventLabel: moment(bill.invoice_date).format('MM/YY') });
    //     await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleInfo'), response,
    //       'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    //       if(!this.platform.is("desktop") && !this.platform.is("mobileweb") && this.gvs.ratingAvailable){
    //         AppRatePlugin.customRatingCall();
    //         this.gvs.ratingAvailable = false;
    //       }
    //   } else if (response != undefined) {
    //     this.gms.analyticsTrackEvent('invoice_action', {eventCategory: 'SICOR/Descarga Factura', eventAction: 'Error/Download Invoice', eventLabel: moment(bill.invoice_date).format('MM/YY') });
    //     await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.downloadBillKo'),
    //       'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    //   }else{
    //     this.gms.analyticsTrackEvent('invoice_action', {eventCategory: 'SICOR/Descarga Factura', eventAction: 'Error/Download Invoice', eventLabel: moment(bill.invoice_date).format('MM/YY')});
    //   }
    // } else {
    //   await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
    //     'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    // }
    let base64Bill = await this.billService.gAppuserViewInvoice(this.user.userName, bill);
    if (base64Bill === undefined) {
      await this.gms.openGenericModal(await this.trans.instant('MODAL.titleError'), await this.trans.instant('MESSAGES.downloadBillKo'),
        'modal-default', await this.trans.instant('BUTTON.agreed'));
      return;
    }
    this.gms.analyticsTrackEvent('invoice_action', { eventCategory: 'SICOR/Descarga Factura', eventAction: 'Accion/Descarga Factura Inicio', eventLabel: moment(invoiceDate).format('MM/YY') });
    let contentType = 'application/pdf';
    let format = '.pdf';
    let invDate = invoiceDate.split('/');
    let formattedDate = '';
    invDate.forEach(fragment => {
      if (formattedDate === '') {
        formattedDate = fragment;
      } else {
        formattedDate = formattedDate + '-' + fragment;
      }
    });
    let base64Data = base64Bill;
    FileSharer.share({
      filename: 'FacturaSICOR-' + formattedDate + format,
      base64Data,
      contentType
    })

    if (!this.platform.is("desktop") && !this.platform.is("mobileweb") && this.gvs.ratingAvailable) {
      AppRatePlugin.customRatingCall();
      this.gvs.ratingAvailable = false;
    }
  }

  async billDetail(invoice: string, invoiceDate: any) {
    // const contentModal = await this.modalService.show(BillDetailComponent, "billDetailModal",
    // {invoice, invoice_date}, this.alarmActivated ? ['w-modal-fp-solid-white', 'alarmActivated'] : ['w-modal-fp-solid-white', 'main-menu-modal']);

    const contentModal = await this.modalCtrl.create({
      component: BillDetailComponent,
      id: 'billDetailModal',
      componentProps: { invoice, invoiceDate },
      cssClass: this.alarmActivated ? ['w-modal-fp-solid-white', 'alarmActivated'] : ['w-modal-fp-solid-white'],
    });

    contentModal.onDidDismiss().then(data => {
      this.zone.run(async () => {
        // await this.modalService.hide();
        await this.gms.startIntervalSatusInstallationEvent();
      });
    });

    contentModal.present().then()
  }
}
